"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.years = exports.weekDays = exports.spanishLocale = exports.months = exports.largueMonths = exports.days = exports.customYears = exports.YEAR_LABEL = exports.MONTH_LABEL = exports.LIMIT_HOUR_TODAY_SATURDAY = exports.LIMIT_HOUR_TODAY_NATURAL_DAY = exports.LIMIT_HOUR_IN_SAME_DAY = exports.DAY_LABEL = void 0;
var days = Array.from({
  length: 31
}, function (_, i) {
  return i + 1;
});
exports.days = days;
var months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
exports.months = months;
var largueMonths = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
exports.largueMonths = largueMonths;
var years = Array.from({
  length: 12
}, function (_, i) {
  return new Date().getFullYear() + 1 - i;
});
exports.years = years;

var customYears = function customYears(numberYears, initialYear) {
  return Array.from({
    length: numberYears
  }, function (_, i) {
    return initialYear + 1 - i;
  });
};

exports.customYears = customYears;
var weekDays = [{
  name: 'Domingo',
  short: 'D',
  isWeekend: true
}, {
  name: 'Lunes',
  short: 'L'
}, {
  name: 'Martes',
  short: 'M'
}, {
  name: 'Miércoles',
  short: 'M'
}, {
  name: 'Jueves',
  short: 'J'
}, {
  name: 'Viernes',
  short: 'V'
}, {
  name: 'Sábado',
  short: 'S',
  isWeekend: true
}];
exports.weekDays = weekDays;
var LIMIT_HOUR_IN_SAME_DAY = '13:00';
exports.LIMIT_HOUR_IN_SAME_DAY = LIMIT_HOUR_IN_SAME_DAY;
var LIMIT_HOUR_TODAY_NATURAL_DAY = '15:00';
exports.LIMIT_HOUR_TODAY_NATURAL_DAY = LIMIT_HOUR_TODAY_NATURAL_DAY;
var LIMIT_HOUR_TODAY_SATURDAY = '10:00';
exports.LIMIT_HOUR_TODAY_SATURDAY = LIMIT_HOUR_TODAY_SATURDAY;
var spanishLocale = {
  months: largueMonths,
  weekDays: weekDays,
  weekStartingIndex: 0,
  getToday: function getToday(gregorianTodayObject) {
    return gregorianTodayObject;
  },
  toNativeDate: function toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },
  getMonthLength: function getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },
  transformDigit: function transformDigit(digit) {
    return digit;
  },
  nextMonth: 'Siguiente mes',
  previousMonth: 'Mes anterior',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  defaultPlaceholder: 'Seleccionar...',
  from: 'desde',
  to: 'hasta',
  digitSeparator: ',',
  yearLetterSkip: 0,
  isRtl: false
};
exports.spanishLocale = spanishLocale;
var DAY_LABEL = 'día';
exports.DAY_LABEL = DAY_LABEL;
var MONTH_LABEL = 'mes';
exports.MONTH_LABEL = MONTH_LABEL;
var YEAR_LABEL = 'año';
exports.YEAR_LABEL = YEAR_LABEL;